import actionTypes from './action-types';

// eslint-disable-next-line import/prefer-default-export
export const selectRole = (id) => ({
  type: actionTypes.SELECT_PRIVILEGE_TEMPLATE,
  id,
});



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/privilege-templates.actions.js